import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { OverallAnalyticsPageStore } from 'pages/analytics/pages/overall/store/overallAnalyticsPageStore'

const OverallAnalyticsPageContext = createContext<OverallAnalyticsPageStore | null>(null)

export const useOverallAnalyticsPageContext = () => {
  const context = useContext(OverallAnalyticsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with OverallAnalyticsPageProvider'
    )

  return context
}

export const OverallAnalyticsPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new OverallAnalyticsPageStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <OverallAnalyticsPageContext.Provider value={store}>
      {children}
    </OverallAnalyticsPageContext.Provider>
  )
}
